import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import DateFnsUtils from '@date-io/date-fns'

import { serverUrl, headerRequest } from '../../lib/funApp/general'

import { Card, Col, Container, Row } from 'react-bootstrap'
import { Button, Icon, Table } from 'semantic-ui-react'
import { MDBIcon } from 'mdbreact'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'

export default class ReportsPerson extends Component {
  constructor() {
    super()
    this.state = {
      dateIni: moment().startOf('month').toDate(),
      dateEnd: moment().endOf('month').toDate(),
      personFilter: '',
      dataPeople: [],
      dataCategory: [],
      dataRecords: [],
      isLoading: false,
      isDisabled: false,
      total: 0,
    }
  }

  componentDidMount() {
    this.getCategories()
    this.getPeople()
  }

  changeDateIni = (value) => {
    this.setState({ dateIni: value })
  }

  changeDateEnd = (value) => {
    this.setState({ dateEnd: value })
  }

  changePersonFilter = (value) => {
    this.setState({ personFilter: value }, () => {
      this.getRecords()
    })
  }

  getPeople = () => {
    axios
      .get(serverUrl + '/src/peoples', { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        const firstPersonId = items.length > 0 ? items[0]._id : ''
        this.setState({ dataPeople: items, personFilter: firstPersonId }, () => {
          this.getRecords()
        })
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  getCategories = () => {
    axios
      .get(serverUrl + '/src/categories', { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        this.setState({ dataCategory: items })
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  getCategoryLabel = (record) => {
    const categories = Array.isArray(record && record.category) ? record.category : []
    if (categories.length === 0) return '-'
    if (categories.length > 1) return 'Diversas'
    const categoryRef = categories[0] && categories[0].category
    if (!categoryRef) return '-'
    if (typeof categoryRef === 'object') return categoryRef.name || '-'
    const found = this.state.dataCategory.find((item) => item && String(item._id) === String(categoryRef))
    return found && found.name ? found.name : '-'
  }

  getRecords = () => {
    this.setState({ isLoading: true, isDisabled: true })

    const targetUrl =
      serverUrl +
      '/src/records?dtstart=' +
      moment(this.state.dateIni).format('YYYY-MM-DD') +
      '&dtend=' +
      moment(this.state.dateEnd).format('YYYY-MM-DD') +
      '&prevision=exclude' +
      '&person=' +
      this.state.personFilter

    axios
      .get(targetUrl, { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        const filteredByPerson = items.filter((record) => {
          if (!record || !this.state.personFilter) return false
          const personId = record.person && typeof record.person === 'object' ? record.person._id : record.person
          return String(personId) === String(this.state.personFilter)
        })
        const sorted = filteredByPerson.sort((a, b) => {
          const dateA = new Date(a && a.date ? a.date : 0).getTime()
          const dateB = new Date(b && b.date ? b.date : 0).getTime()
          return dateA - dateB
        })
        const totalReceitas = sorted
          .filter((record) => record && record.type === 'R')
          .reduce((sum, record) => sum + Math.abs(Number(record && record.value ? record.value : 0)), 0)
        const totalDespesas = sorted
          .filter((record) => record && record.type === 'D')
          .reduce((sum, record) => sum + Math.abs(Number(record && record.value ? record.value : 0)), 0)
        const total = totalReceitas - totalDespesas
        this.setState({ dataRecords: sorted, total, isLoading: false, isDisabled: false })
      })
      .catch((error) => {
        console.log(error.response || error)
        this.setState({ dataRecords: [], total: 0, isLoading: false, isDisabled: false })
      })
  }

  renderTypeSection = (title, records, color) => {
    if (!records.length) {
      return null
    }
    const subtotal = records.reduce(
      (sum, record) => sum + Math.abs(Number(record && record.value ? record.value : 0)),
      0
    )
    return (
      <React.Fragment key={title}>
        <Table.Row>
          <Table.Cell colSpan="4" style={{ backgroundColor: '#fafafa' }}>
            <strong className={`text-${color}`}>{title}</strong>
            <span className="float-right">
              <strong>
                <CurrencyFormat
                  value={subtotal}
                  displayType={'text'}
                  thousandSeparator="."
                  decimalSeparator=","
                  fixedDecimalScale={true}
                  decimalScale={2}
                  prefix="R$ "
                />
              </strong>
            </span>
          </Table.Cell>
        </Table.Row>
        {records.map((record) => (
          <Table.Row key={record._id}>
            <Table.Cell>{moment(record.date).format('DD/MM/YYYY')}</Table.Cell>
            <Table.Cell>{this.getCategoryLabel(record)}</Table.Cell>
            <Table.Cell>{record.history || '-'}</Table.Cell>
            <Table.Cell className="text-right">
              <CurrencyFormat
                value={Math.abs(Number(record.value || 0))}
                displayType={'text'}
                thousandSeparator="."
                decimalSeparator=","
                fixedDecimalScale={true}
                decimalScale={2}
                prefix="R$ "
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </React.Fragment>
    )
  }

  render() {
    const receitas = this.state.dataRecords.filter((record) => record && record.type === 'R')
    const despesas = this.state.dataRecords.filter((record) => record && record.type === 'D')
    const outros = this.state.dataRecords.filter(
      (record) => record && record.type !== 'R' && record.type !== 'D'
    )
    return (
      <>
        <Container>
          <Row className="TitleContainer">
            <Col style={{ padding: '10px' }}>
              <h4>
                <MDBIcon icon="user-tie" className="mr-2 ml-4" />
                Relatórios - Por Pessoa
              </h4>
            </Col>
          </Row>
        </Container>

        <Container className="MainContainer" style={{ backgroundColor: 'white', padding: '5px' }}>
          <Row className="mb-3">
            <Col>
              <Card>
                <Card.Body>
                  <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
                    <Grid item xs={12} md={4}>
                      <FormControl controlid="dateStart">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-start-report-person"
                            label="Início"
                            value={this.state.dateIni}
                            onChange={(e) => this.changeDateIni(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                      <FormControl controlid="dateEnd" className="ml-3">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-end-report-person"
                            label="Fim"
                            value={this.state.dateEnd}
                            onChange={(e) => this.changeDateEnd(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl className="w-100">
                        <InputLabel id="report-person-filter">Pessoa</InputLabel>
                        <Select
                          labelId="report-person-filter"
                          id="report-person-select"
                          value={this.state.personFilter}
                          onChange={(e) => this.changePersonFilter(e.target.value)}
                        >
                          {this.state.dataPeople.map((item) => (
                            <MenuItem key={item._id} value={item._id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4} className="text-right">
                      <Button
                        icon
                        labelPosition="left"
                        color={!this.state.isLoading ? 'blue' : 'grey'}
                        disabled={this.state.isDisabled}
                        onClick={this.getRecords}
                      >
                        {!this.state.isLoading ? 'Atualizar' : 'Aguarde'}
                        <Icon name="sync" loading={this.state.isLoading} />
                      </Button>
                    </Grid>
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className="text-right mb-2">
                    <strong>Total: </strong>
                    <CurrencyFormat
                      value={this.state.total}
                      displayType={'text'}
                      thousandSeparator="."
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale={2}
                      prefix="R$ "
                    />
                  </div>
                  <Table fixed compact celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '130px' }}>Data</Table.HeaderCell>
                        <Table.HeaderCell>Categoria</Table.HeaderCell>
                        <Table.HeaderCell>Histórico</Table.HeaderCell>
                        <Table.HeaderCell className="text-right" style={{ width: '180px' }}>
                          Valor
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {this.state.dataRecords.length > 0 ? (
                        <>
                          {this.renderTypeSection('Receitas', receitas, 'primary')}
                          {this.renderTypeSection('Despesas', despesas, 'danger')}
                          {this.renderTypeSection('Outros', outros, 'secondary')}
                        </>
                      ) : (
                        <Table.Row>
                          <Table.Cell colSpan="4" className="text-center">
                            Nenhum registro encontrado para o filtro.
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
